module.exports = __webpack_public_path__ + "static/media/dacia-go-drive.f1176583.png";